  <div class="shop__cart" (click)="navigateToMyCart()" *ngIf="headerService.currentNavBar!.otherIcon">
    <img src="{{headerService.currentNavBar!.otherIcon}}" alt="shopping cart image">
    @if(cartCountVisible) {
    <div class="shop__cart__count">{{$shopItemCount | async}}</div>
    }
  </div>
